// Favoritos primeiro, sem mexer na ordem relativa dentro de cada grupo (a da API, por nome).
export function sortFavoritesFirst(vinculos) {
  return [...vinculos].sort((a, b) => Number(Boolean(b.favorito)) - Number(Boolean(a.favorito)));
}

// O cadastro de plantão já vem com o favorito escolhido só quando ele é o único: com dois
// ou mais, escolher um seria um chute.
export function singleFavorite(vinculos) {
  const favoritos = vinculos.filter((v) => v.favorito);
  return favoritos.length === 1 ? favoritos[0] : null;
}
